var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('b-modal',{attrs:{"width":"680px","active":_vm.isModalTagEditActive,"on-cancel":_vm.closeTagEditModal},on:{"update:active":function($event){_vm.isModalTagEditActive=$event}}},[_c('TemplateTagEdit',{attrs:{"isTagProgress":_vm.isTagProgress,"targetObj":_vm.targetObj,"currentTagList":_vm.currentTagList,"defaultTagList":_vm.defaultTagList},on:{"addTag":_vm.addTag,"deleteTag":_vm.deleteTag}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-485b12be","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/common/ModalTagEdit.vue
// module id = null
// module chunks = 